/*
    Create by Pierre Marsot on 05/12/2017
*/
import {
    LOAD_BALISES_ERROR,
    LOAD_BALISES_SUCCESS,
    REMOVE_BALISES_ERROR,
    REMOVE_BALISES_SUCCESS,
    ADD_BALISE_SUCCESS,
    ADD_BALISE_ERROR,
} from '../actions/balises';

let initialState = {
    balises: [],
};

export default function balises(state = initialState, action = {}){
    switch(action.type){
        case LOAD_BALISES_ERROR:
            return {
                ...state,
                balises: [],
            };

        case LOAD_BALISES_SUCCESS:
            if(!action || !action.balises){
                return {
                    ...state,
                    balises: [],
                };
            }

            return {
                ...state,
                balises: action.balises,
            };

        case REMOVE_BALISES_SUCCESS:
            if(!action || !action.id_balise){
                return state;
            }

            return {
                ...state,
                balises: state.balises.filter((balise) => {
                    return balise._id !== action.id_balise;
                }),
            };

        case ADD_BALISE_SUCCESS:
            if(!action || !action.balise){
                return state;
            }

            return {
                ...state,
                balises: state.balises.concat(action.balise),
            };

        case ADD_BALISE_ERROR:
        case REMOVE_BALISES_ERROR:
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/balises.js